import React from 'react'
import { Container, Image } from 'react-bootstrap'
import logo from "../../assets/images/logo.svg"
import Inputs from './inputs'
import "./header.scss"

const Header = () => {
  return (
    <Container className='text-center' id='headerContainer'>
        <Image src={logo} id='logo' alt='logo'/>
        <h1>We are launching <span>soon!</span></h1>
        <p>Subscribe and get notified</p>
        <Inputs/>
    </Container>
  )
}

export default Header
